import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { ColumnStyle } from '@website-builder/model/structure/column/column-style';
import { ColumnLayout } from '@website-builder/model/structure/column/column-layout';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';
import { WidgetNormalizer } from '@website-builder/widgets/normalizer/widget-normalizer';

export class Column {
  id = makeEntityId(EntityIdPrefix.COLUMN);
  widgets = new Array<BaseWidget>();
  style = new ColumnStyle();
  layout = new ColumnLayout();
  src: string;

  static normalizeInPlace(column: Partial<Column>): Column {
    const pureColumn = new Column();

    column.id = column.id ?? pureColumn.id;
    column.widgets = (column.widgets ?? []).map(widget => WidgetNormalizer.normalizeInPlace(widget));
    column.src = column.src ?? pureColumn.src;

    column.style = ColumnStyle.normalize(column.style);
    column.layout = ColumnLayout.normalize(column.layout);

    return column as Column;
  }
}
